<template>
  <pagefra>
    <div class="message container">
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <!-- <el-form-item label="所属区域">
              <areaCascader ref="ac" :multiple="true" :checkStrictly="true"></areaCascader>
            </el-form-item> -->
            <el-form-item :label="$l('所属城市')">
              <el-input
                v-model="form.city"
                :placeholder="$l('所属城市')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('地盘名称')">
              <el-input
                v-model="form.domainName"
                :placeholder="$l('地盘名称')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('工号')">
              <el-input
                v-model="form.jobNum"
                :placeholder="$l('工号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('接收人')">
              <el-input
                v-model="form.receiver"
                :placeholder="$l('接收人')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('手机')">
              <el-input
                v-model="form.telNum"
                :placeholder="$l('手机')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('短信类型')">
              <el-select v-model="form.faultType" :placeholder="$l('短信类型')">
                <el-option :label="$l('短信类型')" value="-1"></el-option>
                <el-option :label="$l('停梯')" value="1"></el-option>
                <el-option :label="$l('停梯恢复')" value="2"></el-option>
                <el-option :label="$l('困人')" value="3"></el-option>
                <el-option :label="$l('完成困人救援')" value="4"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
          >
            <el-table-column
              :label="$l('序号')"
              type="index"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('城市')"
              prop="city"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('地盘名称')"
              prop="domainName"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('大楼名称')"
              prop="buildingName"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('梯号')"
              prop="elevatorNum"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('工号')"
              prop="jobNum"
              align="center"
              min-width="150"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('接收人')"
              prop="receiver"
              align="center"
              min-width="150"
            ></el-table-column>
            <el-table-column
              :label="$l('手机')"
              prop="telNum"
              align="center"
              min-width="150"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('发送时间')"
              prop="sendTime"
              align="center"
              min-width="150"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('发送状态')"
              prop="smsStatus"
              align="center"
              min-width="150"
              :formatter="smsStatusFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('短信类型')"
              prop="faultType"
              align="center"
              min-width="150"
              :formatter="faultTypeFormatter"
            ></el-table-column>
            <!-- <el-table-column label="接收时间" prop="receiveTime" align="center" width="150" sortable></el-table-column> -->
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import breadcrumb from "@/components/breadcrumb.vue";
import areaCascader from "@/components/areaCascader.vue";
import global from "@/mixins/global.js";
export default {
  name: "message",
  mixins: [global],
  components: {
    panel,
    breadcrumb,
    areaCascader,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        city: "",
        domainName: "",
        jobNum: "",
        receiver: "",
        telNum: "",
        faultType: "",
        dataPermissionList: [],
      },
      tableData: [],
      loading: false,
    };
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      // this.form.dataPermissionList = this.$refs.ac.getSelectedList();
      this.tableData = [];
      this.loading = true;
      this.$http
        .post(this.$apiConfig.search_elevator_stop_sms_url, this.form)
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    showMsg() {
      this.dialogVisible = true;
    },
    smsStatusFormatter(row) {
      if (row.smsStatus == 0) {
        return "失败";
      }
      return "成功";
    },
    faultTypeFormatter(row) {
      if (row.faultType == 1) {
        if (row.smsType == 1) {
          return "停梯";
        } else {
          return "停梯恢复";
        }
      } else {
        if (row.smsType == 1) {
          return "困人";
        } else {
          return "完成困人救援";
        }
      }
    },
  },
  mounted() {
    if (this.loaded) {
      this.initData();
    }
  },
};
</script>
<style lang="scss" scoped>
.message {
}
</style>
